import { createContext, useContext, useState, type ReactNode } from 'react';

interface HeaderGradientContextValue {
  extendGradient: boolean;
  setExtendGradient: (value: boolean) => void;
  backdropGradientOpacity: number;
  setBackdropGradientOpacity: (value: number) => void;
}

const HeaderGradientContext = createContext<HeaderGradientContextValue | null>(null);

export function HeaderGradientProvider({ children }: { children: ReactNode }) {
  const [extendGradient, setExtendGradient] = useState(false);
  const [backdropGradientOpacity, setBackdropGradientOpacity] = useState(1);
  return (
    <HeaderGradientContext.Provider
      value={{ extendGradient, setExtendGradient, backdropGradientOpacity, setBackdropGradientOpacity }}
    >
      {children}
    </HeaderGradientContext.Provider>
  );
}

export function useHeaderGradient() {
  return useContext(HeaderGradientContext);
}
